import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoPalisade from "../palisade/InfoPalisade";
const Footer = lazy(() => import('../footer/Footer'));
function Palisade() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Palosade es el SUV familiar perfecto. Cómodo, amplio, seguro, con diseño vanguardista y tecnológico. Disfruta los mejores momentos con tus seres queridos"
        />
        <meta
          name="keywords"
          content="SUV, Hyundai, Hyundai Palisade, Palisade, familiar, seguro, amplio, confortable, elegante"
        />
        <title>Hyundai Palisade</title>
      </Helmet>
      <Menu />
      <InfoPalisade />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Palisade;